import React, { Suspense, lazy } from "react";
import { Box, CircularProgress } from "@mui/material";
import type ClientHistoryModalComponent from "../../clients/components/ClientHistoryModal";
import type ListaNegraModalComponent from "../../clients/components/ListaNegraModal";
import type EditReservationModalComponent from "../../reservations/components/EditReservationModal";
import type EditEstacionamientoModalComponent from "../../reservations/components/EditEstacionamientoModal";
import type GodModeEditModalComponent from "../../godMode/components/GodModeEditModal";
import type AdminReservationModalComponent from "../../reservations/components/AdminReservationModal";
import type HistorialDeReservaDialogComponent from "../../logs/components/HistorialDeReservaDialog";

// Lazy loading de modales pesados
const ClientHistoryModal = lazy(
  () => import("../../clients/components/ClientHistoryModal")
);
const ListaNegraModal = lazy(
  () => import("../../clients/components/ListaNegraModal")
);
const EditReservationModal = lazy(
  () => import("../../reservations/components/EditReservationModal")
);
const EditEstacionamientoModal = lazy(
  () => import("../../reservations/components/EditEstacionamientoModal")
);
const GodModeEditModal = lazy(
  () => import("../../godMode/components/GodModeEditModal")
);
const AdminReservationModal = lazy(
  () => import("../../reservations/components/AdminReservationModal")
);
// Lazy a propósito: el historial abre fichas de reserva, y la ficha abre el historial.
const HistorialDeReservaDialog = lazy(
  () => import("../../logs/components/HistorialDeReservaDialog")
);

// Componente de loading para modales
const ModalLoadingFallback: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "200px",
      p: 3,
    }}
  >
    <CircularProgress size={40} />
  </Box>
);

// Wrapper para modales con lazy loading
type ClientHistoryModalProps = React.ComponentProps<
  typeof ClientHistoryModalComponent
>;
type ListaNegraModalProps = React.ComponentProps<
  typeof ListaNegraModalComponent
>;
type EditReservationModalProps = React.ComponentProps<
  typeof EditReservationModalComponent
>;
type EditEstacionamientoModalProps = React.ComponentProps<
  typeof EditEstacionamientoModalComponent
>;
type GodModeEditModalProps = React.ComponentProps<
  typeof GodModeEditModalComponent
>;
type AdminReservationModalProps = React.ComponentProps<
  typeof AdminReservationModalComponent
>;
type HistorialDeReservaDialogProps = React.ComponentProps<
  typeof HistorialDeReservaDialogComponent
>;

export const LazyClientHistoryModal: React.FC<ClientHistoryModalProps> = (
  props
) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <ClientHistoryModal {...props} />
  </Suspense>
);

export const LazyListaNegraModal: React.FC<ListaNegraModalProps> = (props) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <ListaNegraModal {...props} />
  </Suspense>
);

export const LazyEditReservationModal: React.FC<EditReservationModalProps> = (
  props
) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <EditReservationModal {...props} />
  </Suspense>
);

export const LazyEditEstacionamientoModal: React.FC<
  EditEstacionamientoModalProps
> = (props) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <EditEstacionamientoModal {...props} />
  </Suspense>
);

export const LazyGodModeEditModal: React.FC<GodModeEditModalProps> = (
  props
) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <GodModeEditModal {...props} />
  </Suspense>
);

export const LazyAdminReservationModal: React.FC<AdminReservationModalProps> = (
  props
) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <AdminReservationModal {...props} />
  </Suspense>
);

export const LazyHistorialDeReservaDialog: React.FC<HistorialDeReservaDialogProps> = (
  props
) => (
  <Suspense fallback={<ModalLoadingFallback />}>
    <HistorialDeReservaDialog {...props} />
  </Suspense>
);
